/*
 * @Author: shiguang
 * @Date: 2023-04-26 10:48:59
 * @LastEditors: liangliang
 * @LastEditTime: 2023-06-02 14:59:12
 * @Description: 静态地址
 */
export const CDN_HOST = 'https://static-s.theckb.com';
export const STATIC_URL = {};
